// extracted by mini-css-extract-plugin
export var centerText = "_cd-8";
export var container = "_cd-0";
export var doughnutContainer = "_cd-7";
export var legend = "_cd-a";
export var legendItemColorDisplay = "_cd-b";
export var legendItemLabel = "_cd-d";
export var legendItemValue = "_cd-c";
export var lg = "_cd-5";
export var maxWidth = "_cd-9";
export var md = "_cd-4";
export var responsive = "_cd-6";
export var sm = "_cd-3";
export var xs = "_cd-2";
export var xxs = "_cd-1";